<template>
    <div>
        <div v-if="saveMessage !== ''" class="alert alert-primary alert-dismissible fade show" role="alert">
            {{saveMessage}}
            <button @click="clearSaveMessage" type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div id="form">
            <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="inputGroup-sizing-lg">Key</span>
                </div>
                <input class="form-control" v-model="key.Key" type="text">
            </div>
            <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="inputGroup-sizing-lg">Language</span>
                </div>
                <select v-model="key.Language.Title" class="custom-select">
                        <option :value="null">All languages</option>
                        <option v-for="(language, index) in systemLanguages" :key="index" :value="language.title" :selected="language.title == key.Language.Title">{{language.longTitle}}</option>
                </select>
            </div>
            <button @click="editKey" class="btn btn-primary">Save</button>
        </div>
       
    </div>
</template>

<script>
export default {
    data () {
        return {
            key: {
                Key : '',
                Language : {},
            },
            saveMessage: ''
        }
    },
    computed : {
        systemLanguages: function(){
            return this.$store.getters.systemLanguages
        }
    },
    methods : {
        getKey : function(){
            let self = this
            let key = this.key.Key == '' ? this.$route.params.key : this.key.Key
            this.$http.get('/api/languages/key/' + key)
            .then(response => {
                self.key = response.data
                if(self.key.Language === null){
                    self.key.Language = {
                        Title: "ALL"
                        }
                }
            })
        },
        editKey : function(){
            let self = this
            let key = this.$route.params.key
            this.$http.put(`/api/languages/${key}/edit-key`, {
	                "key": this.key.Key,
	                "languageCode": this.key.Language.Title
            })
            .then(response => {
                key = self.key.Key
                this.$router.push(`/admin/languages/${key}/modify-key`)
                self.saveMessage = 'Changes saved successfully!'
            })
            .catch(error => {
                self.saveMessage = 'There was a problem saving your changes'
            })
        },
        formatKey : function(value){
            //SCREAMING_SNAKE_CASE formatting
            this.key.Key = value.toUpperCase().replace('-', '_').replace(' ','_').replace(/[^_\dA-Z]/, '')
        },
        clearSaveMessage: function(){
            this.saveMessage = ''
        }
    },
    mounted : function(){
        this.getKey()
    },
    watch : {
        'key.Key' : function(value){
            this.formatKey(value)
        }
    }
}
</script>

<style lang="scss" scoped>
    div{
    span.input-group-text {
        width: 100px;
        }
    }
</style>
